import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { LoggerCodes } from '@shared/modules/logger/constants/logger.constants';
import { LoggerService } from '@shared/modules/logger/service/logger.service';
import { External } from '@store/actions';
import * as fromRootStore from '@store/index';
import { selectTransactionsTotal } from '@store/selectors/transaction-state/transaction-state.selectors';
import { CookieService } from 'ngx-cookie-service';
import { map, Observable, of, take } from 'rxjs';

@Injectable()
export class TransactionsGuard implements CanActivate {
  constructor(
    private readonly globalStore: Store<fromRootStore.State>,
    private readonly cookieService: CookieService,
    private readonly location: Location,
    private readonly loggerService: LoggerService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (this.cookieService.get('routeGuard') === 'OFF') {
      return of(true);
    }

    return this.globalStore.select(selectTransactionsTotal).pipe(
      take(1),
      map((total) => {
        if (total > 0) {
          return true;
        }
        const url = this.location.prepareExternalUrl('/guide');
        this.globalStore.dispatch(External({ url }));
        this.loggerService.warn(
          {
            eventId: 'guard-no-transactions',
            message: `User attempted to access route ${route.url} without any transactions in state.`,
          },
          LoggerCodes.NULL_FAILURE,
        );
        return false;
      }),
    );
  }
}
